import { Colors } from "../constants/colors";

export default {
  variants: [
    {
      props: { variant: "dark" },
      style: {
        borderColor: Colors.GREY400
      },
    },
    {
      props: { variant: "dashed" },
      style: {
        borderStyle: "dashed",
        borderColor: Colors.GREY400
      },
    },
  ],
};
